import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgRouteAlt(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M18 0a2 2 0 01.402 3.96l-1.905 5.713a2 2 0 01-2.823 2.823L7.96 14.403a2 2 0 11-.633-1.899l5.713-1.905a2.002 2.002 0 011.558-1.558l1.905-5.713A2 2 0 0118 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('RouteAlt')(SvgRouteAlt);
